import {
    Checkbox,
    Dropdown,
    Form,
    Input,
    Menu,
    Spin,
    Tag,
    Select,
    Pagination,
    Cascader,
} from 'antd';
import React, { useState, useEffect } from 'react';
import useNotify from '../../../context/Notification/useNotify';
import { useForm } from 'antd/lib/form/Form';
import ModalDelete from '../../../components/Shared/modal/delete';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import ModalRename from '../../policy/PrivacyNotices/components/ModalRename';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    DownloadOutlined,
    LoadingOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import IconWaring from '../../../assets/Images/icons/icon-waring';
import ConsentService from '../../../services/Consent.service';
import EmptyCustom from '../../../assets/Images/icons/emptyCustom';
import usePermission from '../../../hooks/usePermission';

const { Option } = Select;

export default function ConsentList({
    data,
    setCurrentSelectList,
    currentSelectList,
    setSearchValue,
    searchValue,
    searchConsentList,
    setSearchTemplateCategory,
    searchTemplateCategory,
    dataTotal,
}) {
    const [form] = useForm();
    const { t, i18n } = useTranslation();
    const [searchBy, setSearchBy] = useState('modifyDate');
    const [sortOrder, setSortOrder] = useState('desc');
    const [displayValue, setDisplayValue] = useState(
        `${t('Update Date')} / ${t('Descending')}`
    );
    const lang = i18n?.language;
    const [loading, setLoading] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [openRename, setOpenRename] = useState(false);
    const [dataObject, setDataObject] = useState(null);
    const [select, setSelect] = useState([]);
    const [dataSelection, setDataSelection] = useState([]);
    const [allSelection, setAllSelection] = useState([]);
    const [allDataSelection, setAllDataSelection] = useState([]);
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const notify = useNotify();
    const navigate = useNavigate();
    const [trigger, setTrigger] = useState(false);

    const [loadingDownload, setLoadingDownload] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    let templateCategory = [
        {
            name: t('Consent.AllConsentCategory'),
            value: '',
        },
        {
            name: t('Consent.ConsentTemplate'),
            value: 'Consent',
        },
        {
            name: t('Consent.TermConditionTemplate'),
            value: 'Term',
        },
    ];

    const cascaderOptions = [
        {
            value: 'modifyDate',
            label: t('Update Date'),
            children: [
                {
                    value: 'asc',
                    label: t('Ascending'),
                },
                {
                    value: 'desc',
                    label: t('Descending'),
                },
            ],
        },
        {
            value: 'consentName',
            label: t('Consent.ConsentName'),
            children: [
                {
                    value: 'asc',
                    label: t('Ascending'),
                },
                {
                    value: 'desc',
                    label: t('Descending'),
                },
            ],
        },
    ];

    const keywordSearch = Form.useWatch('keyword', form);
    const templateCategorySearch = Form.useWatch('templateCategory', form);

    useEffect(() => {
        setSearchValue(keywordSearch);
        setSearchTemplateCategory(templateCategorySearch);

        const searchField =
            searchBy === 'consentName'
                ? `consentName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : searchBy;

        searchConsentList({
            s: searchField,
            sd: sortOrder,
            consentName: keywordSearch,
            consentType: templateCategorySearch,
            p: currentPage.page,
            ps: currentPage.pageSize,
        });
        setLoading(false);
    }, [currentPage]);

    useEffect(() => {
        setSearchValue(keywordSearch);
        setSearchTemplateCategory(templateCategorySearch);

        const searchField =
            searchBy === 'consentName'
                ? `consentName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : searchBy;
        setCurrentPage({
            page: 1,
            pageSize: 10,
        })
        searchConsentList({
            s: searchField,
            sd: sortOrder,
            consentName: keywordSearch,
            consentType: templateCategorySearch,
            p: 1,
            ps: 10,
        });
        setLoading(false);
    }, [trigger]);

    const exportConsent = async () => {
        try {
            setLoadingDownload(true);
            const res = await ConsentService.exportConsent({
                consentIds: [...select],
            });
            const objectURL = window.URL.createObjectURL(new Blob([res?.data]));
            const link = document.createElement('a');
            link.href = objectURL;
            // link.download = `Consent_List__${moment(
            //     new Date()
            // ).format('YYYY-MM-DD')}.xlsx`;
            const filename =
                res.headers['content-disposition'].split('filename=')[1];
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            await setLoadingDownload(false);
        } catch (error) {
            setLoadingDownload(false);
        }
    };

    // Delete Consent
    const [loadingDelete, setLoadingDelete] = useState(false);
    const deleteConsent = async (id) => {
        setLoadingDelete(true);
        try {
            const { data } = await ConsentService.deleteConsent(id);
            if (data?.resultMsg === 'SUCCESS') {
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                    timeOut: 1800,
                });
                await searchConsentList('');
            } else {
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to deleted'),
                });
            }
        } catch (error) {
            const err = error?.data;
            console.log(err);
            if (err?.errorData?.msg.includes('binding with template')) {
                const message = err?.errorData?.msg?.split(': ');
                console.log(message);
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Consent.ErrorTemplate', {
                        consentType: message[1],
                    }),
                    closeable: true,
                    timeOut: 5000,
                });
            }
        }
    };

    const menu = (item) => (
        <Menu
            items={[
                {
                    label: t('common.Edit'),
                    onClick: () => {
                        navigate(`${item?.consentId}`);
                    },
                },
                {
                    label: t('common.Delete'),
                    onClick: () => {
                        item?.status === 'Draft'
                            ? setOpenDelete(true)
                            : setConfirmDelete(true);
                        setDataObject(item);
                    },
                },
            ]}
        />
    );

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.lastPublishVersion}
                    </Tag>
                );
            default:
                return <></>;
        }
    };

    // Handler for dropdown selection
    const handleCascaderChange = (value, selectedOptions) => {
        const [newSearchBy, newSortOrder] = value;
        setSearchBy(newSearchBy);
        setSortOrder(newSortOrder);

        const newDisplayValue = `${t(
            newSearchBy === 'modifyDate'
                ? t('Update Date')
                : t('Consent.consentName')
        )} / ${t(newSortOrder === 'asc' ? t('Ascending') : t('Descending'))}`;
        const searchField =
            newSearchBy === 'consentName'
                ? `consentName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : newSearchBy;

        setDisplayValue(newDisplayValue);
        searchConsentList({
            s: searchField,
            sd: newSortOrder,
            consentName: searchValue,
            consentType: searchTemplateCategory,
            p: 1,
            ps: 10,
        });
    };

    const getCascaderValue = () => {
        return [searchBy, sortOrder];
    };

    const { isAuditor } = usePermission();

    return (
        <>
            <div className=" w-full col-span-2">
                <Spin spinning={loading}>
                    <div className="dropdown-sort bg-white rounded-t-md shadow-sm text-xs font-semibold text-gray-PHX px-3 pb-3 pt-3 border-b-2 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                        <p className="text-dark text-sm font-semibold">
                            {t('Search Filter')}
                        </p>
                        <Cascader
                            options={cascaderOptions}
                            onChange={handleCascaderChange}
                            allowClear={false}
                            size="large"
                            placeholder={false}
                            showArrow
                            className="w-full mb-4"
                            value={getCascaderValue()}
                        ></Cascader>

                        <Form
                            scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                            }}
                            form={form}
                            onValuesChange={(value) => {
                                setTrigger(!trigger);
                            }}
                        >
                            <Form.Item
                                name="templateCategory"
                                className="w-full mb-4"
                            >
                                <Select
                                    placeholder={t(
                                        'Consent.AllTemplateCategory'
                                    )}
                                    defaultValue={templateCategory[0]?.value}
                                    size="large"
                                >
                                    {templateCategory?.map((e, i) => (
                                        <Option key={i} value={e.value}>
                                            {e.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name={'keyword'} className={'m-0'}>
                                <Input
                                    size="large"
                                    placeholder={t('Consent.SearchConsent')}
                                    prefix={<SearchOutlined />}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="bg-white shadow-sm text-xs font-semibold text-gray-PHX px-3 pb-3 pt-3">
                        <div
                            className={`flex space-x-4 items-center bg-white w-full py-4 px-3 rounded-lg ${
                                data?.length > 0 ? '' : 'hidden'
                            }`}
                        >
                            <div className="flex items-center h-full">
                                <Checkbox
                                    disabled={isAuditor}
                                    checked={checkedAll}
                                    onClick={(e) => {
                                        setCheckedAll(e.target.checked);
                                        let selectAll = data?.map(
                                            (data) => data.consentId
                                        );

                                        let IsSelectAll = allSelection;

                                        let IsDataSelection = allDataSelection;
                                        // All Data Select
                                        selectAll?.forEach((res, i) => {
                                            if (!IsSelectAll.includes(res)) {
                                                IsSelectAll.push(res);
                                            }
                                        });
                                        data?.forEach((res, i) => {
                                            if (
                                                !IsDataSelection.includes(res)
                                            ) {
                                                IsDataSelection.push(res);
                                            }
                                        });
                                        // Select Per Page
                                        let allSelectPerPage = [];
                                        let allDataSelectionPerPage = [];
                                        IsSelectAll?.forEach((res, i) => {
                                            if (selectAll.includes(res)) {
                                                allSelectPerPage.push(res);
                                            }
                                        });
                                        IsDataSelection?.forEach((res, i) => {
                                            if (
                                                selectAll.includes(
                                                    res?.consentId
                                                )
                                            ) {
                                                allDataSelectionPerPage.push(
                                                    res
                                                );
                                            }
                                        });

                                        if (e.target.checked) {
                                            setSelect(allSelectPerPage);
                                            setAllSelection(IsSelectAll);
                                            setAllDataSelection(
                                                allDataSelectionPerPage
                                            );
                                            setDataSelection(IsDataSelection);
                                        } else {
                                            setIsCheckedAll(false);
                                            let itemSelect = allSelection;
                                            let itemDataSelecttion =
                                                allDataSelection;
                                            // All Data Select
                                            selectAll?.forEach((res, i) => {
                                                let set = itemSelect.filter(
                                                    (data) => data !== res
                                                );
                                                itemSelect = set;
                                            });
                                            data?.forEach((res, i) => {
                                                let set =
                                                    itemDataSelecttion.filter(
                                                        (data) =>
                                                            data?.consentId !==
                                                            res?.consentId
                                                    );
                                                itemDataSelecttion = set;
                                            });

                                            // Select Per Page
                                            const selectPerPage = [];
                                            const dataSelectionPerPage = [];
                                            itemSelect?.forEach((res) => {
                                                if (selectAll.includes(res)) {
                                                    selectPerPage.push(res);
                                                }
                                            });
                                            itemDataSelecttion?.forEach(
                                                (res) => {
                                                    if (
                                                        selectAll.includes(
                                                            res?.consentId
                                                        )
                                                    ) {
                                                        dataSelectionPerPage.push(
                                                            res
                                                        );
                                                    }
                                                }
                                            );
                                            setSelect(selectPerPage);
                                            setAllSelection(itemSelect);
                                            setDataSelection(
                                                dataSelectionPerPage
                                            );
                                            setAllDataSelection(
                                                itemDataSelecttion
                                            );
                                        }
                                    }}
                                />
                            </div>
                            <div className="font-semibold text-sm flex w-full justify-between items-center">
                                <div className="whitespace-nowrap flex space-x-2 items-center">
                                    <span>
                                        {t(`Consent.SelectAll`)} (
                                        {isCheckedAll
                                            ? data?.length
                                            : select.length}
                                        )
                                    </span>
                                    <div className="flex items-center space-x-2">
                                        {select.length > 0 ? (
                                            <a
                                                onClick={() => {
                                                    exportConsent();
                                                }}
                                                className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                                            >
                                                {loadingDownload ? (
                                                    <LoadingOutlined />
                                                ) : (
                                                    <DownloadOutlined />
                                                )}
                                            </a>
                                        ) : (
                                            <span
                                                className="cursor-not-allowed bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg"
                                                style={{
                                                    padding: '4px 7px',
                                                    color: '#7B67FB',
                                                }}
                                            >
                                                <DownloadOutlined
                                                    className="text-[#ADADAD]"
                                                    disabled
                                                />
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="">
                                    {t('TotalItems', { length: dataTotal })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white shadow-sm overflow-y-auto overflow-x-hidden h-[62vh] max-h-[60vh] pb-5 border-b-2 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                        {data?.length > 0 ? (
                            data.map((item, i) => {
                                return (
                                    <div
                                        key={i}
                                        className={`cursor-pointer custom-list-consent hover:bg-gray-50  ${
                                            currentSelectList?.consentId ===
                                            item.consentId
                                                ? 'select'
                                                : ''
                                        }`}
                                    >
                                        <div />
                                        <div
                                            key={item?.consentId}
                                            className="my-2 flex w-full items-center"
                                        >
                                            <div className="pr-4">
                                                <Checkbox
                                                    disabled={isAuditor}
                                                    checked={select.find(
                                                        (s) =>
                                                            s ===
                                                            item?.consentId
                                                    )}
                                                    onClick={(e) => {
                                                        if (e.target.checked) {
                                                            let selectAll =
                                                                data?.map(
                                                                    (data) =>
                                                                        data?.consentId
                                                                );
                                                            let allSelectData =
                                                                [
                                                                    ...allSelection,
                                                                    item?.consentId,
                                                                ];
                                                            let selectData = [];
                                                            allSelectData?.forEach(
                                                                (res) => {
                                                                    if (
                                                                        selectAll?.includes(
                                                                            res
                                                                        )
                                                                    ) {
                                                                        selectData?.push(
                                                                            res
                                                                        );
                                                                    }
                                                                }
                                                            );
                                                            let allSelectDataSelection =
                                                                [
                                                                    ...allDataSelection,
                                                                    item,
                                                                ];
                                                            let dataSelectionData =
                                                                [];
                                                            allSelectDataSelection?.forEach(
                                                                (res) => {
                                                                    if (
                                                                        selectAll?.includes(
                                                                            res?.consentId
                                                                        )
                                                                    ) {
                                                                        dataSelectionData?.push(
                                                                            res
                                                                        );
                                                                    }
                                                                }
                                                            );
                                                            setSelect(
                                                                selectData
                                                            );
                                                            setAllSelection(
                                                                allSelectData
                                                            );
                                                            setDataSelection(
                                                                dataSelectionData
                                                            );
                                                            setAllDataSelection(
                                                                allSelectDataSelection
                                                            );
                                                            if (
                                                                select.length +
                                                                    1 ===
                                                                data?.length
                                                            ) {
                                                                setCheckedAll(
                                                                    true
                                                                );
                                                            }
                                                        } else {
                                                            setSelect(
                                                                select.filter(
                                                                    (data) =>
                                                                        data !==
                                                                        item.consentId
                                                                )
                                                            );
                                                            setAllSelection(
                                                                allSelection.filter(
                                                                    (data) =>
                                                                        data !==
                                                                        item.consentId
                                                                )
                                                            );
                                                            setDataSelection(
                                                                dataSelection.filter(
                                                                    (data) =>
                                                                        data?.consentId !==
                                                                        item?.consentId
                                                                )
                                                            );
                                                            setAllDataSelection(
                                                                allDataSelection.filter(
                                                                    (data) =>
                                                                        data?.consentId !==
                                                                        item?.consentId
                                                                )
                                                            );
                                                            setCheckedAll(
                                                                false
                                                            );
                                                            setIsCheckedAll(
                                                                false
                                                            );
                                                        }
                                                    }}
                                                ></Checkbox>
                                            </div>
                                            <button
                                                className="flex-1 space-y-1 text-left"
                                                onClick={() => {
                                                    setCurrentSelectList(item);
                                                }}
                                            >
                                                <div className="font-semibold text-gray-500 text-xs">
                                                    {item?.consentType || '-'}
                                                </div>
                                                <p
                                                    className="font-semibold text-purple-PHX text-base line-clamp-2 w-full whitespace-pre-wrap"
                                                    style={{
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {lang === 'en'
                                                        ? item?.consentNameEn ||
                                                          '-'
                                                        : item?.consentNameTh ||
                                                          '-'}
                                                </p>
                                                <div className="flex items-center">
                                                    {_getTagStatus(item)}
                                                    <div
                                                        className="text-[#F0536F] text-[12px] text-right"
                                                        hidden={
                                                            item?.version ===
                                                                item?.lastPublishVersion ||
                                                            item?.status ===
                                                                'Draft'
                                                        }
                                                    >
                                                        <div className="flex items-center py-2">
                                                            <svg
                                                                width="10"
                                                                height="11"
                                                                viewBox="0 0 10 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="5"
                                                                    cy="5.5"
                                                                    r="5"
                                                                    fill={
                                                                        '#F0536F'
                                                                    }
                                                                />
                                                            </svg>
                                                            <span>
                                                                &nbsp;&nbsp;
                                                            </span>
                                                            <div>
                                                                {t(
                                                                    'Consent.InformationChanged'
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                            <div className="px-1 hover:opacity-80">
                                                <Dropdown
                                                    placement="bottomCenter"
                                                    arrow
                                                    overlay={menu(item)}
                                                    disabled={isAuditor}
                                                    className="disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    <button>
                                                        <svg
                                                            width={32}
                                                            height={32}
                                                            viewBox="0 0 32 32"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <rect
                                                                width={32}
                                                                height={32}
                                                                rx={6}
                                                            />
                                                            <path
                                                                d="M19.75 16C19.75 17.0312 20.5937 17.875 21.625 17.875C22.6562 17.875 23.5 17.0313 23.5 16C23.5 14.9687 22.6563 14.125 21.625 14.125C20.5937 14.125 19.75 14.9687 19.75 16Z"
                                                                fill="#7B67FB"
                                                            />
                                                            <path
                                                                d="M17.875 16C17.875 14.9687 17.0313 14.125 16 14.125C14.9687 14.125 14.125 14.9687 14.125 16C14.125 17.0312 14.9687 17.875 16 17.875C17.0312 17.875 17.875 17.0313 17.875 16Z"
                                                                fill="#7B67FB"
                                                            />
                                                            <path
                                                                d="M12.25 16C12.25 14.9687 11.4063 14.125 10.375 14.125C9.34375 14.125 8.5 14.9687 8.5 16C8.5 17.0312 9.34375 17.875 10.375 17.875C11.4062 17.875 12.25 17.0313 12.25 16Z"
                                                                fill="#7B67FB"
                                                            />
                                                        </svg>
                                                    </button>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="h-[54vh] grid items-center justify-center">
                                <div className="-mt-16">
                                    <EmptyCustom text={t('common.noData')} />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex justify-center py-4 bg-white rounded-b-md">
                        <Pagination
                            current={currentPage?.page || 1}
                            pageSizeOptions={[10, 25, 50, 100]}
                            defaultPageSize={currentPage?.pageSize}
                            total={currentPage?.total || dataTotal}
                            onChange={(page, pageSize) => {
                                const pageValue = {
                                    ...currentPage,
                                    page: page,
                                    pageSize: pageSize,
                                };
                                setLoading(true);
                                setCurrentPage(pageValue);
                            }}
                            showSizeChanger
                        />
                    </div>
                </Spin>
            </div>
            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={
                    dataObject?.status === 'Draft'
                        ? t('Consent.ModalTitleDeleteDraft')
                        : t('Consent.ModalTitleDeleteDraft')
                }
                text={
                    dataObject?.status === 'Draft'
                        ? `${t('Consent.ModalDeleteDraft', {
                              version: dataObject?.latestPublishVersion,
                          })}`
                        : `${t('Consent.ModalDetailDeletePublish', {
                              consent_type: dataObject?.consentType,
                          })} \n${t('Consent.ModalDeletePublish', {
                              version: dataObject?.lastPublishVersion,
                          })}`
                }
                handelOk={
                    // handelDelete
                    () => {
                        deleteConsent(dataObject?.consentId);
                    }
                }
                handelClose={() => {
                    setOpenDelete(false);
                    setLoading(false);
                }}
            />
            <ModalConfirm
                loading={loading}
                open={confirmDelete}
                title={t('Consent.ModalTitleConfirmDelete')}
                text={
                    lang === 'en'
                        ? `Please check that no system uses the "Consent Key" \nof this data before deleting it.`
                        : `โปรดตรวจสอบว่าไม่มีระบบใดใช้ "Consent Key" \nของข้อมูลนี้ก่อนที่จะลบ`
                }
                confirmText={t('Consent.CheckConfirm')}
                handelOk={() => {
                    setConfirmDelete(false);
                    setOpenDelete(true);
                }}
                handelClose={() => {
                    setConfirmDelete(false);
                    setLoading(false);
                }}
                icon={<IconWaring />}
            />
            <ModalRename
                form={form}
                loading={loading}
                open={openRename}
                handelClose={() => {
                    setOpenRename(false);
                    setLoading(false);
                }}
                handelOk={
                    // handelRename
                    () => setOpenRename(false)
                }
            />
        </>
    );
}
